import DojoView from "csi/page/DojoView";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { TYPE_SIZE_CHART_ADMIN, useCompositionStore } from "./CompositionStore";

interface CompositionDataProps {}

const CompositionData: FunctionComponent<CompositionDataProps> = observer(function CompositionData() {
	const { routerStore } = useStore();
	const { viewParams } = useCompositionStore();

	return (
		<DojoView
			fullHeight
			nodeUrl={routerStore?.locationUrl}
			viewId="CompositionMaterials"
			viewNodeType={TYPE_SIZE_CHART_ADMIN}
			viewParams={viewParams}
		/>
	);
});

export default CompositionData;